<!-- <div class="swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide" *ngFor="let item of arrayResult; let i = index">
        <div *ngIf="item && item.name" class="card shadow">
          <ul>
            <li class="pack">{{ item.name }}</li>
            <h2 class="price-box__discount">
              <span class="price-box__dollar" *ngIf="item.price">$</span>{{ item.price }}
            </h2>
            <h3 class="price-box__price">
              ${{ getOldPrice(item.price) }}
            </h3>
            <p *ngIf="item.name !== 'Basic'" style="font-size: 10px">
              * incluye los servicios del paquete anterior
            </p>
          </ul>
          <mat-spinner *ngIf="isLoading()" style="font-size: 10px;" class="center"></mat-spinner>
          <ul>
            <li *ngFor="let pro of item.products" class="bottom-bar">{{ pro }}</li>
            <li>
              <mat-spinner *ngIf="item.products.length === 0"></mat-spinner>
            </li>
          </ul>
          <ul>
            <li class="paid" *ngIf="isPackChosen(item)">
              Contratado <i class="fas fa-check my-icon" style="color: #FFFFFF;"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
    
    <div class="swiper-pagination"></div>
  </div> -->
  

  <div class="container">
    <div class="swiper-container">
      <div class="swiper-wrapper">

        <div class="swiper-slide" *ngFor="let item of arrayResult; let i = index">
          <div class="card shadow pricing-card">
            <div class="card-body text-center">
              <h5 class="card-title plan-name">{{ item.name }}</h5>
              <p class="card-subtitle mb-3 text-muted">Perfect for individuals</p>
              <div class="price-section">
                <h2 class="price">${{ item.price }}</h2>
                <p class="old-price text-muted"><s>${{ getOldPrice(item.price) }}</s></p>
              </div>
              <p class="text-muted small">* incluye los servicios del paquete anterior</p>
              <hr>
              <ul class="list-unstyled">
                <li>
                    <mat-spinner *ngIf="item.products.length === 0"></mat-spinner>
                  </li>
                <li *ngFor="let pro of item.products"><i class="fas fa-check-circle text-success me-2"></i>{{ pro }}</li>
              </ul>
              <button *ngIf="isPackChosen(item)" class="btn btn-primary btn-block mt-3">Contratado</button>
              <button *ngIf="!isPackChosen(item)" class="btn btn-primary btn-block mt-3">Choose Plan</button>
            </div>
          </div>
        </div>
        <!-- Repeat for additional plans -->
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
  